<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-orders">
        <section class="mc-orders__tabs mc-tabs mc-tabs--fr">
          <div v-if="historybuyLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
          <div v-if="historybuyError" class="mc-error">{{ historybuyError }}</div>
          <div v-if="historybuyLoaded" class="mc-tabs__body-wrapper">
            <div>
              <ul class="mc-orders__list">
                <li v-for="item in historybuy" class="mc-orders__item mc-orders-item">
                  <div class="mc-orders-item__top">
                                            <span class="mc-orders-item__status">
                                                {{ item.header.status }}
                                            </span>
                    <div class="mc-orders-item__title">
                      {{ item.header.name }} от {{ item.header.date_create }}
                    </div>
                  </div>

                      <swiper
                          wrapperTag="ul"
                          :modules="modules"
                          :pagination="false"
                          slides-per-view="auto"
                          :space-between="10"
                          :freeMode="true"
                          class="mc-orders-item__slider swiper-free-mode"
                          wrapperClass="mc-orders-item__slider-list">
                        <swiper-slide v-for="product in item.items" class="mc-orders-item__slider-item" tag="li">
                        <router-link :to="product.url" class="mc-orders-item__product-wrapper">
                          <img class="mc-orders-item__product-image" :src="product.picture" width="60" height="100" alt="">
                        </router-link>
                        </swiper-slide>
                      </swiper>
                  <div class="mc-orders-item__bottom">
                    <div class="mc-orders-item__bottom-left">
                      {{ item.header.total }} ₽
                    </div>
                    <div class="mc-orders-item__bottom-right">
                      <router-link :to="'/historybuy/'+item.header.guid+'/'" class="mc-orders-item__link">
                        Подробнее
                      </router-link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import {mapActions, mapGetters} from "vuex";
export default {
  data: () => ({
    modules: [Navigation, Scrollbar,Pagination],
    tabShow: 1,
    tabGlide: {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    },
    currentPage: 1,
    loadingMore: false,
  }),
  created() {
    this.fetchHistoryBuy({page:this.currentPage});
    window.addEventListener('scroll', this.handleScroll);
  },
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    ...mapGetters([
      'historybuy',
      'historybuyLoading',
      'historybuyError',
      'historybuyLoaded',
      'noMoreHistoryBuy',
    ]),
  },
  methods: {
    ...mapActions([
      'fetchHistoryBuy'
    ]),
    handleScroll() {
      if (this.$route.name != 'historybuy') {
        window.removeEventListener('scroll', this.handleScroll);
      }
      // Calculate if we've reached the bottom of the page
      const bottomOfWindow = Math.max(
          window.scrollY,
          document.documentElement.scrollTop,
          document.body.scrollTop
      ) + window.innerHeight >= document.documentElement.scrollHeight - 200;
      console.log(this.noMoreHistoryBuy);
      // If we are at the bottom of the page and not currently loading more products
      if (bottomOfWindow && !this.loadingMore && this.historybuyLoaded && !this.noMoreHistoryBuy) {
        this.loadMoreOrders();
      }
    },
    async loadMoreOrders() {
      debugger;
      // Set loading state
      if (this.loadingMore)
        return;
      this.loadingMore = true;

      // Get current page from store or local state
      const nextPage = this.currentPage + 1;
      await this.fetchHistoryBuy({ page:nextPage});
      this.loadingMore = false;
      this.currentPage++;
    },
  },
}
</script>

